import PropTypes from 'prop-types';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../i18n';
import {
  ExperimentsProvider,
  withExperiments,
} from '@wix/wix-experiments-react';
import { ModuleRegistry } from 'react-module-container';
import { ModuleId } from '@wix/business-manager-api';
import { ReactQueryCacheProvider } from 'react-query';
import { ContactsMobxProvider } from '../ContactsListPage/providers/MobxProvider';
import { BiLoggerProvider } from '../../helpers/providers/BiLoggerProvider';
import { FontUpgrade } from 'wix-style-react';

@withExperiments
class MainComponent extends React.Component {
  static propTypes = {
    debug: PropTypes.bool,
    accountLanguage: PropTypes.any,
    config: PropTypes.any,
    metaSiteId: PropTypes.any,
    experiments: PropTypes.any,
    children: PropTypes.any,
    baseUrl: PropTypes.any,
    stores: PropTypes.any,
    viewMode: PropTypes.string,
  };

  componentWillMount() {
    const {
      debug,
      accountLanguage,
      config: { topology },
      metaSiteId,
      experiments,
      viewMode,
      baseUrl,
      stores,
      liveSite,
    } = this.props;

    this.stores = stores({
      msid: metaSiteId,
      baseUrl,
      debug,
      experiments,
      locale: accountLanguage,
      topology,
      viewMode,
      liveSite,
    });
    this.il8n = i18n({
      locale: accountLanguage,
      baseStaticsUrl: topology.contactsStaticsUrl,
    });
  }

  render() {
    return (
      <ContactsMobxProvider {...this.stores}>
        <I18nextProvider i18n={this.il8n}>
          <FontUpgrade
            active={this.props.experiments.enabled(
              'specs.crm.ContactsMadeforFont',
            )}
          >
            {this.props.children}
          </FontUpgrade>
        </I18nextProvider>
      </ContactsMobxProvider>
    );
  }
}

export const mainBuilder = ({
  baseUrl,
  Root,
  givenExperiments = null,
  stores,
}) => (props) => {
  const { instance, metaSiteId } = ModuleRegistry.getModule(
    ModuleId.Contacts,
  ).moduleParams;
  const experiments =
    givenExperiments ||
    (ModuleRegistry.getModule(ModuleId.Contacts) &&
      ModuleRegistry.getModule(ModuleId.Contacts).getExperiments()) ||
    [];
  const opts = {
    experiments,
  };

  if (!Object.keys(experiments).length) {
    opts.scope = 'my-account';
  }
  return (
    <ReactQueryCacheProvider>
      <ExperimentsProvider options={{ ...opts }}>
        <BiLoggerProvider msid={metaSiteId}>
          <MainComponent stores={stores} baseUrl={baseUrl} {...props}>
            <Root {...props} />
          </MainComponent>
        </BiLoggerProvider>
      </ExperimentsProvider>
    </ReactQueryCacheProvider>
  );
};
